/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Tokens_BodyInputs */

const cs_import_tokens_body = /** @type {(inputs: Import_Tokens_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dejte IT týmům token místo uživatelského účtu. Otevřou /import a vloží ho.`)
};

const en_import_tokens_body = /** @type {(inputs: Import_Tokens_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give your IT team a token instead of a user login. They open /import and paste it.`)
};

/**
* | output |
* | --- |
* | "Give your IT team a token instead of a user login. They open /import and paste it." |
*
* @param {Import_Tokens_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_tokens_body = /** @type {((inputs?: Import_Tokens_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Tokens_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_tokens_body(inputs)
	return cs_import_tokens_body(inputs)
});